let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2KubE")).then(() => parcelRequire('7yEMV'));